import React from 'react';

import { config, moment } from 'data';
import { useLang } from 'hooks';
import { DashboardLayout } from 'layouts';
import { Grid } from 'components/ui';

import BalanceCard from './BalanceCard';
import FeeChart from './FeeChart';
import IncomingPaymentsCard from './IncomingPaymentsCard';
import IncomingPaymentsChart from './IncomingPaymentsChart';
import OutgoingPaymentsCard from './OutgoingPaymentsCard';

const dateFrom = moment().subtract(config.DASHBOARD_STATISTICS_INTERVAL, 'day').startOf('day');
const dateTo = moment().endOf('day');

const DashboardPage = () => {
  const lang = useLang();

  return (
    <DashboardLayout title={lang.get('dashboard.title')}>
      <Grid.Row>
        <Grid.Col sm={12} lg={8}>
          <BalanceCard dateFrom={dateFrom} dateTo={dateTo} />
        </Grid.Col>
        <Grid.Col sm={12} lg={8}>
          <IncomingPaymentsCard dateFrom={dateFrom} dateTo={dateTo} />
        </Grid.Col>
        <Grid.Col sm={12} lg={8}>
          <OutgoingPaymentsCard dateFrom={dateFrom} dateTo={dateTo} />
        </Grid.Col>
        <Grid.Col lg={16}>
          <IncomingPaymentsChart />
        </Grid.Col>
        <Grid.Col sm={12} lg={8}>
          <FeeChart />
        </Grid.Col>
      </Grid.Row>
    </DashboardLayout>
  );
};

export default DashboardPage;
